const METHODS = {
  GET: "get",
  POST: "post",
  PATCH: "patch",
  PUT: "put",
  DELETE: "delete",
} as const;

export type HttpMethod = (typeof METHODS)[keyof typeof METHODS];

export default METHODS;
